import React, { Component } from 'react';
import './Comic.css';

class Comic extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEditing: false,
            editedTitle: this.props.title,
            editedIssueNum: this.props.issue,
            editedVariant: this.props.variant
        }
        this.handleRemove = this.handleRemove.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleSave = this.handleSave.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCopySecured = this.handleCopySecured.bind(this);

    }
    handleRemove(evt) {
        this.props.removeComic(this.props.id);
    }
    handleEdit() {
        this.setState({isEditing: !this.state.isEditing})
    }
    handleChange(evt) {
        this.setState({
            [evt.target.name]: evt.target.value
        })
    }
    handleSave(evt) {
        evt.preventDefault();
        this.props.updateComic(this.props.id, this.state.editedTitle, this.state.editedIssueNum, this.state.editedVariant);
        this.setState({
            isEditing: false
        })
    }
    handleCopySecured(evt) {
        this.props.secureComic(this.props.id);
    }
   
    render() {
        let result;
        let displayVariantLogic = this.props.variant ? "display" : "d-none";
        let displayExtraCopyLogic = this.props.extraCopy ? "display" : "d-none";
        if (this.state.isEditing) {
            result = (
                <div className={this.props.copySecured ? "Comic CopySecured" : "Comic"}>
                    <h1 onClick={this.handleCopySecured}>[&nbsp;&nbsp;<span className={this.props.copySecured ? "display" : "d-none"} >&#x2713;</span>&nbsp;&nbsp;]</h1>
                    <form onSubmit={this.handleSave} className="editForm">
                        <input type="text"
                            value={this.state.editedTitle}
                            name="editedTitle"
                            className="editedTitle"
                            placeholder="Enter Book Title"
                            onChange={this.handleChange} />
                        <label htmlFor="editedIssueNum">#</label>
                        <input type="text"
                            value={this.state.editedIssueNum}
                            name="editedIssueNum"
                            className="editedIssueNum"
                            placeholder="Enter Issue #"
                            onChange={this.handleChange} />
                        <input type="text"
                            value={this.state.editedVariant}
                            name="editedVariant"
                            className="editedVariant"
                            placeholder="Variant Artist"
                            onChange={this.handleChange} />
                        <button className="btn btn-tertiary comic-btn">Save</button>
                    </form>
                </div>
            )
        } else {
            result = (
                <div className={this.props.copySecured ? "Comic CopySecured" : "Comic"}>
                    <div className="header-text-container">
                        <h1 onClick={this.handleCopySecured}>[&nbsp;&nbsp;<span className={this.props.copySecured ? "display" : "d-none"} >&#x2713;</span>&nbsp;&nbsp;]</h1>
                        <h2 onClick={this.handleEdit}>{this.props.title} #{this.props.issue}</h2>
                        <h3 onClick={this.handleEdit} className="variant-color"><span className={displayVariantLogic}>(</span>{this.props.variant}<span className={displayVariantLogic}>)&nbsp;</span></h3>
                        <h3 className="extra-copy-color"><span className={displayExtraCopyLogic}>(Extra Copy</span>{this.props.extraCopy}<span className={displayExtraCopyLogic}>)</span></h3>
                    </div>
                    
                    <button onClick={this.handleRemove} className="btn btn-tertiary comic-btn">X</button>
                </div>
            )
        };
          return (result)
        
        
    }
}

export default Comic;